<template>
  <input
    :id="id"
    :value="formatter(value)"
    @input="onInput($event)"
    @keyup.enter="onKeyUpEnter"
    @keyup.esc="onKeyUpEsc"
    :maxlength="maxLength"
    :disabled="disabled"
    autocomplete="off"
    type="tel"
    :placeholder="placeholder"
  >
</template>

<script setup>

import { ref, watch } from 'vue'

const props = defineProps({
  id: {
    type: String,
    default: null
    // required: true,
  },
  maxLength: {
    type: String,
    default: '32'
  },
  // isInt: {
  //   type: Boolean,
  //   default: true
  // },
  isNegative: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: ''
  },
  parentValue: {
    type: String,
    default: ''
  },
  // classes: {
  //   type: String,
  //   default: 'w-full rounded-md border-0 py-1.5 px-4 h-10 text-base shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-inset focus:ring-gray-400/70'
  // },
  maxValue: {
    type: Number,
    default: 0,
  },
  decimals: {
    type: Number,
    default: 2,
  }
})

const emit = defineEmits(['input', 'keyUpEnter', 'keyUpEsc'])
const value = ref('')

function onKeyUpEnter() {
  emit('keyUpEnter')
}

function onKeyUpEsc() {
  emit('keyUpEsc')
}

function formatter(sum) {
  let parts = sum.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(".");
}

const onInput = (event) => {
  if (props.decimals <= 0) {
    let intRegEx = props.isNegative ? /[^0-9-]|(?!^)-/g : /[^0-9]/g
    event.target.value = event.target.value.replace(intRegEx, '')
    value.value = event.target.value.replace(intRegEx, '')
  } else {
    let inputValue = event.target.value;

    if (inputValue.endsWith(",", ".")) {
      inputValue = inputValue.slice(0, -1) + ".";
    }

    let floatRegEx = props.isNegative ? /(?!^-?\d*\.?\d*$)[^\d.-]|(?!^)-/g : /(?!^\d*\.?\d*$)[^\d.]/g

    inputValue = inputValue.replace(floatRegEx, '');

    if (props.decimals > 0 && inputValue.includes(".")) {
      const [integerPart, decimalPart] = inputValue.split(".");
      if (decimalPart.length > props.decimals) {
        inputValue = integerPart + "." + decimalPart.slice(0, props.decimals);
      }
    }

    if (inputValue.startsWith(".")) {
      inputValue = inputValue.slice(1);
    }

    if (!/^-?\d*\.?\d*$/.test(inputValue)) {
      inputValue = inputValue.slice(0, -1);
    }

    event.target.value = inputValue;
    value.value = inputValue;
  }

  if (props.maxValue > 0 && +value.value > props.maxValue) {
    value.value = ''
  }

  let num = props.decimals <= 0 ? parseInt(value.value, 10) : parseFloat(value.value);
  if (isNaN(num)) {
    emit('input', '')
  } else {
    emit('input', num)
  }
}

function updateValues() {
  if (props.parentValue !== '') {
    value.value = props.parentValue
  } else {
    value.value = ''
  }
}

updateValues()

watch(() => props.parentValue, () => {
  updateValues()
})
</script>

<style scoped>

</style>